module.exports = __webpack_public_path__ + "media/images/lp/ashinaga-aai/home/home-leadership-box-2-image-sp-54ad416d35f1b53784ce8c8f82ae4570.png";